// Packages
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
// Components
import App from 'App';
import { ThemeProvider } from 'modules/theme';
import { loadLogRocket } from 'sessionRecording';
import { loadSentry, reactRootErrorHandlers } from 'sentryConfig';
// Redux
import store from 'redux/store';
// Styles
import 'antd/dist/reset.css';
import 'styles/main.scss';

const MONITORING_START_TIMEOUT_MS = 2000;

if (import.meta.env.MODE === 'production') {
  console.warn = () => {}; // Disable warnings
}

createRoot(document.getElementById('root') as HTMLElement, reactRootErrorHandlers).render(
  <Provider store={store}>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </Provider>,
);

// After first paint, so the monitoring SDKs do not delay it. The timeout bounds how long errors in
// the meantime wait in the buffer (see sentryConfig). Safari has no requestIdleCallback.
const startMonitoring = () => {
  loadSentry().catch(() => undefined);
  loadLogRocket();
};

if ('requestIdleCallback' in window) {
  window.requestIdleCallback(startMonitoring, { timeout: MONITORING_START_TIMEOUT_MS });
} else {
  setTimeout(startMonitoring, MONITORING_START_TIMEOUT_MS);
}
